import React, { ReactNode } from "react";

import NextHead from "next/head";

interface Props {
    metaData?: { [name: string]: string };
    children?: ReactNode[];
}

const defaultMetaData = {
    robots: "noindex, follow, noarchive, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
};

/**
 * This behaves mostly the same as the regular page head but leaves out unnecessary features.
 * Most importantly, the IVW code is left out which crashes the widget inside an iframe.
 */
export const HeadWidgets = ({ children, metaData = defaultMetaData }: Props) => {
    return (
        <NextHead>
            <title>Finance Widget</title>
            {Object.entries(metaData).map(([key, value]) => {
                return <meta key={`meta-${key}`} name={key} content={value} />;
            })}
            {children}
        </NextHead>
    );
};
